function isValidEOSAddress(address, currency, networkType) {
    const regex = /^[a-z0-9]+$/g; // Must be numbers and lowercase letters only
    return address.search(regex) !== -1 && address.length === 12;
}

export default {
    isValidAddress(address, currency, networkType) {
        return isValidEOSAddress(address, currency, networkType);
    },
};
